import React from 'react';

const ProductList = () => {
  return (
    <div>
      <h3>Product List</h3>
    </div>
  );
};

export default ProductList;
